"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const LootTable_1 = __importDefault(require("../../../../structures/LootTable"));
const SimpleMonster_1 = __importDefault(require("../../../../structures/SimpleMonster"));
const RareDropTable_1 = __importStar(require("../../../subtables/RareDropTable"));
const BlackDragonTable = new LootTable_1.default()
    .every('Dragon bones')
    .every('Black dragonhide')
    /* Weapons and armour */
    .add('Mithril 2h sword', 1, 4)
    .add('Mithril axe', 1, 3)
    .add('Mithril battleaxe', 1, 3)
    .add('Rune knife', 2, 3)
    .add('Mithril kiteshield', 1, 1)
    .add('Adamant platebody', 1, 1)
    .add('Rune longsword', 1, 1)
    /* Runes and ammunition */
    .add('Adamant javelin', 30, 20)
    .add('Fire rune', 50, 8)
    .add('Adamant dart(p)', 16, 7)
    .add('Law rune', 10, 5)
    .add('Blood rune', 15, 3)
    .add('Air rune', 75, 1)
    /* Coins */
    .add('Coins', 196, 40)
    .add('Coins', 330, 10)
    .add('Coins', 690, 1)
    /* Other */
    .add('Dragon javelin heads', 10, 6)
    .add('Adamantite bar', 1, 3)
    .add('Chocolate cake', 1, 3)
    /* RDT */
    .add(RareDropTable_1.default, 1, 2)
    .add(RareDropTable_1.GemTable, 1, 3)
    /* Tertiary */
    .tertiary(35, 'Ensouled dragon head')
    .tertiary(128, 'Clue scroll (hard)')
    .tertiary(500, 'Clue scroll (elite)')
    .tertiary(10000, 'Draconic visage');
exports.default = new SimpleMonster_1.default({
    id: 252,
    name: 'Black Dragon',
    table: BlackDragonTable,
    aliases: ['black dragon', 'black drags']
});
//# sourceMappingURL=BlackDragon.js.map